import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import citizenIdBackImg from "../../assets/images/citizen-id-back.png"; 

const TooltipCard = () => {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="w-5 h-5 rounded-full text-base bg-primary text-center ml-1 relative cursor-pointer"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="text-secondary-text-invert font-medium">?</span>
      {showTooltip && (
        <div className="w-80 h-72 -left-40 pt-7 flex flex-col items-center border rounded-2xl border-primary bg-secondary-background absolute z-50">
          <div className="font-medium">{t("citizen_id_back_example")}</div>
          <img
            className="w-64 h-48"
            src={citizenIdBackImg}
            alt="citizen id back"
          />
          <div className="-mt-4 text-sm font-normal text-center">
            <div>{t("citizen_id_back_example_desc1")}</div>
            <div className="inline-block">
              {t("citizen_id_back_example_desc2")}
            </div>
            <span className="text-base font-medium text-primary-text block">
              {t("citizen_id_back_example_desc3")}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TooltipCard;
